export default class User {
  public static readonly INFO = '/user/info';
  public static readonly CONTACT_INFO = '/user/contact-info';
  public static readonly UPDATE_USERNAME = '/user/username';
  public static readonly CHANGE_PASSWORD = '/user/password';
}
